import React, { useState } from 'react';
import { Link, animateScroll as scroll } from 'react-scroll';
import logo from '../assets/sabc.png';
import Toggle from './utils/Toggler';
import styled from 'styled-components';
import { Menu, X } from 'react-feather';

const ThemedDiv = styled.div`
  background: ${({ theme }) => theme.bg2};
  color: ${({ theme }) => theme.textColor};
  .nav-options.active {
    background: ${({ theme }) => theme.bg1};
  }
`;

const Nav = ({ theme, toggleTheme }) => {
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const scrollToTop = () => {
    scroll.scrollToTop();
  };

  return (
    <ThemedDiv>
      <div className='nav'>
        <div className='logo-container'>
          <img
            src={logo}
            className='nav-logo'
            alt='Logo'
            onClick={scrollToTop}
          />
        </div>

        <ul className={click ? 'nav-options active' : 'nav-options'}>
          <li className='nav-item'>
            <Link
              onClick={closeMobileMenu}
              activeClass='active'
              to='landing'
              spy={true}
              smooth={true}
              offset={0}
              duration={500}
            >
              .home
            </Link>
          </li>
          <li className='nav-item'>
            <Link
              onClick={closeMobileMenu}
              activeClass='active'
              to='skills'
              spy={true}
              smooth={true}
              offset={0}
              duration={500}
            >
              .skills
            </Link>
          </li>
          <li className='nav-item'>
            <Link
              onClick={closeMobileMenu}
              activeClass='active'
              to='fullstack'
              spy={true}
              smooth={true}
              offset={0}
              duration={500}
            >
              .fullstack
            </Link>
          </li>
          <li className='nav-item '>
            <Link
              onClick={closeMobileMenu}
              activeClass='active'
              to='frontend'
              spy={true}
              smooth={true}
              offset={0}
              duration={500}
            >
              .frontend
            </Link>
          </li>
          <li className=' nav-item '>
            <Link
              onClick={closeMobileMenu}
              activeClass='active'
              to='contact'
              spy={true}
              smooth={true}
              offset={0}
              duration={500}
            >
              .contact
            </Link>
          </li>
          <li className=' nav-item ' onClick={closeMobileMenu}>
            <Toggle theme={theme} toggleTheme={toggleTheme} />
          </li>
        </ul>
        <div className='mobile-menu' onClick={handleClick}>
          {click ? <X className='menu-icon' /> : <Menu className='menu-icon' />}
        </div>
      </div>
    </ThemedDiv>
  );
};

export default Nav;
